import { BsStars } from 'react-icons/bs';
import { V2Networks } from '@shared/utils/config/networkAddresses';
import { useLocalStorage } from 'usehooks-ts';
import { useRouter } from 'next/router';
import Image from 'next/image';
import SlidingModal from '../home/mobile/SlidingModal';
import { Button } from '../ui/button';
import getNetworkLogo from '@/lib/misc/getNetworkLogo';
import { useMixpanel } from '@/lib/misc/mixpanel';
import { useSession } from '@/contexts/LitSessionProvider';
import useGetStableCoinData from '@/hooks/explore/useGetStableCoinTokenData';
import { useRecentToken } from '@/hooks/saved/useRecentToken';
import { ImageWithFallback } from '../shared/NextImageFallback';
export default function CashModal({
  onTokenClick,
  isModalOpen,
  toggleModal,
  token
}) {
  const [showInfo, setShowInfo] = useLocalStorage('showInfo', true);
  const {
    handleSaveRecent
  } = useRecentToken();
  const {
    LogToMixpanel,
    EVENTS,
    CATEGORIES
  } = useMixpanel();
  const {
    PKP
  } = useSession();
  const router = useRouter();
  const {
    data: stableCoinData
  } = useGetStableCoinData();
  return <SlidingModal heightFit={true} isOpen={isModalOpen} onClose={toggleModal} data-sentry-element="SlidingModal" data-sentry-component="CashModal" data-sentry-source-file="CashModal.tsx">
      <div className='px-6 pb-6 text-[16px]'>
        <div>
          <div className='mb-2 border-genius-blue rounded-xl overflow-hidden border-[1px]'>
            <div className='flex items-center w-full mb-2 p-3'>
              <div className='relative'>
                <Image className='w-[24px] h-[24px]' src={`/static/tokenlogos/${token.name}.png`} alt='eth' width={24} height={24} data-sentry-element="Image" data-sentry-source-file="CashModal.tsx" />
                <Image className='w-[10px] h-[10px] absolute bottom-0 right-0' src='/static/tokenlogos/gen.png' alt='eth' width={10} height={10} data-sentry-element="Image" data-sentry-source-file="CashModal.tsx" />
              </div>
              <div className='w-2/5 ta-l pl-4'>
                <p className='text-genius-cream text-[16px]'>{token.name.toUpperCase()}</p>
                <p className='text-genius-cream/50 text-[12px]'>{token.name.toUpperCase()}</p>
              </div>
              <div className='flex flex-col text-right text-wrap w-[55%]'>
                <p className='text-base/4 text-genius-cream text-right text-wrap'>$1.0</p>
                <div className='flex gap-1 items-center justify-end text-right'>
                  <p className='text-[12px] font-light text-genius-cream/50'>Stable</p>
                </div>
              </div>
            </div>
            <p className='text-genius-cream/50 text-[12px] ta-l m-0 px-2'>
              {showInfo ? `Very soon, Genius will enable you to spend all your ${token.name.toUpperCase()} as
                one, regardless of which network it’s on. We call this:` : `There are multiple versions of ${token.name.toUpperCase()} on different networks. We recommend selecting the version of the network you are trading on to keep your fees low.`}
            </p>
            <div className='gradient-genius-sides p-3.5 py-2 flex items-center justify-between mt-4'>
              {showInfo ? <>
                  {' '}
                  <div className='flex items-center'>
                    <p className='flex items-center text-genius-cream text-[16px]'>
                      <BsStars />
                      Magic Spend
                    </p>
                    <div className='bg-black ml-2 text-[10px] text-genius-cream rounded-full p-1 px-2'>
                      Coming Soon
                    </div>
                  </div>
                  <div className='flex items-center'>
                    <Button onClick={() => setShowInfo(false)} className='ml-2 bg-genius-blue md:hover:bg-genius-blue text-[12px]  text-genius-cream underline rounded-full'>
                      Got it
                    </Button>
                  </div>
                </> : <> </>}
            </div>
          </div>
          <div className='mt-4 max-h-[60vh]'>
            {token.networks.map((logo, index) => {
            const network = logo;
            return <div onClick={() => {
              const address = token.tokens[network];
              const token0 = stableCoinData?.find(token => token.token.address?.toLowerCase() === address?.toLowerCase());
              console.log('stableCoinData token0', token0, address);
              const tokenItem = token0.token;
              if (onTokenClick) {
                LogToMixpanel({
                  pkp: PKP,
                  eventName: EVENTS.search.clickStableToken,
                  category: CATEGORIES.search,
                  metaData: {
                    tokenAddress: address,
                    source: 'mobile',
                    network: network
                  }
                });
                onTokenClick(tokenItem);
                handleSaveRecent({
                  tokenData: {
                    ...token0,
                    ...tokenItem,
                    address: tokenItem?.address,
                    networkId: tokenItem?.networkId,
                    imageLargeUrl: tokenItem?.imageLargeUrl,
                    symbol: tokenItem?.symbol,
                    token: tokenItem,
                    timeStamp: Date.now()
                  }
                });
              } else {
                router.push(`/asset?address=${tokenItem?.address}&networkId=${tokenItem?.networkId}`);
              }
            }} key={index} className='flex items-center mb-2 h-[70px]'>
                  <div className='relative'>
                    <Image className='w-[24px] h-[24px]' src={`/static/tokenlogos/${token.name}.png`} alt='eth' width={24} height={24} />

                    <ImageWithFallback className='w-[16px] h-[16px] absolute -bottom-1 left-4' src={getNetworkLogo(network)} alt={network} width={10} height={10} />
                  </div>
                  <div className='pl-4 flex flex-col items-start'>
                    <p className='text-genius-cream text-[16px]'>{token.name.toUpperCase()}</p>
                    <p className='text-genius-cream/50 text-[12px] ta-l flex items-end space-x-2'>
                      {token.name.toUpperCase()}{' '}
                      <p className='ml-1'>on {V2Networks[network].name}</p>
                    </p>
                  </div>
                  <div className='flex-1 text-right'>
                    <p className='text-genius-cream'>$1.0</p>
                    <div className='flex items-center justify-end'>
                      <p className='text-[12px] text-genius-cream/50'>Stable</p>
                    </div>
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>
    </SlidingModal>;
}